import { useBackend } from "../../services";

export const useDeleteOriginCountry = () => {
  const { deleteRequest } = useBackend();
  const deleteOriginCountry = (parameters: IDeleteOriginCountryParameters) =>
    deleteRequest("originCountries", parameters);
  return { deleteOriginCountry };
};

export interface IDeleteOriginCountryParameters {
  uuid: string;
}
